import { useCallback } from 'react';
import { withTiming } from 'react-native-reanimated';

import { useFloor } from './FloorContext';
export const useGameFlowControls = ({
  setGameType,
  setRenderInstructionsCard,
  scrollViewRef,
  setIsPlaying,
  setCorrects,
  setErrors,
  setFinalScore,
  setSelectedObject,
  setRenderExitCard,
  setTimeFinished,
  exploreFilterOpacity,
  resetAttempts,
}) => {
  const {
    translateFirstFloorFront,
    translateSecondFloorFront,
    translateThirdFloorFront,
    translateFirstFloorSide,
    translateFront,
    translateThirdFloorSide,
    translateSide,
    translateSecondFloorSide,
  } = useFloor();
  const handlePlay = useCallback(() => {
    setGameType('play');
    setRenderInstructionsCard(false);
    scrollViewRef.current.scrollToEnd({ animated: true });
    setIsPlaying(true);
    resetAttempts();
  }, [resetAttempts]);

  const handleExplore = useCallback(() => {
    setGameType('explore');
    exploreFilterOpacity.value = withTiming(0.6, { duration: 800 });
    scrollViewRef.current.scrollToEnd({ animated: true });
  }, []);

  const handleEnd = useCallback(() => {
    setGameType('');
    exploreFilterOpacity.value = withTiming(0, { duration: 200 });
    setCorrects({});
    setErrors({});
    setFinalScore(0);
    setSelectedObject(null);
    setRenderExitCard(false);
    setTimeFinished(false);
    resetAttempts();
    translateFirstFloorFront.value = translateFront;
    translateSecondFloorFront.value = translateFront;
    translateThirdFloorFront.value = translateFront;
    translateFirstFloorSide.value = translateSide;
    translateSecondFloorSide.value = translateSide;
    translateThirdFloorSide.value = translateSide;
    scrollViewRef.current.scrollTo({ x: 0, y: 0, animated: true });
    setIsPlaying(false);
  }, [resetAttempts]);

  return { handlePlay, handleExplore, handleEnd };
};
